export default state => state.giftcard.form;
